// extracted by mini-css-extract-plugin
export default {"main":"mainWrapper_main__+FpC3"};